import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const TypedGoogleOAuthProvider = GoogleOAuthProvider as React.FC<{
  clientId: string;
  children: React.ReactNode;
}>;

const GoogleProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <TypedGoogleOAuthProvider clientId="696759296982-2uamtnn83seq8tgvkduq8titf10qjtk8.apps.googleusercontent.com">
      {children}
    </TypedGoogleOAuthProvider>
  );
};

export default GoogleProvider;
